import { type ReactNode, forwardRef } from 'react';
import { Button, type ButtonProps } from './Button';
import type { ButtonVariant } from './button-variants';

export type IconButtonVariant = 'outline' | 'ghost' | 'solid';

export type IconButtonProps = Omit<
  ButtonProps,
  'size' | 'variant' | 'children'
> & {
  variant?: IconButtonVariant;
  children: ReactNode;
};

function mapVariant(variant: IconButtonVariant): ButtonVariant {
  if (variant === 'solid') {
    return 'primary';
  }
  return variant;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(
    { variant = 'ghost', children, type = 'button', ...props },
    ref,
  ) {
    return (
      <Button
        ref={ref}
        type={type}
        size='icon'
        variant={mapVariant(variant)}
        {...props}
      >
        {children}
      </Button>
    );
  },
);
